import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../project';
import { RatingService } from '../rating.service';
import { UtilsService } from '../utils.service';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-edit-project-users-box',
  templateUrl: './edit-project-users-box.component.html',
  styleUrls: ['./edit-project-users-box.component.css']
})
export class EditProjectUsersBoxComponent implements OnInit {
  @Input() project: Project;

  constructor(
    private ratings: RatingService,
    private utils: UtilsService,
    private users: UsersService
  ) { }

  ngOnInit() {
  }

  get userLs() {
    let ls = [];
    this.users.list.forEach((x) =>
      ls.push([x['email'], x['displayName'],
        x['email'] === this.utils.email, this.project.users.has(x['email'])])
    );
    return ls;
  }

  switchUser(email) {
    this.project.switchUser(email);
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/edit-project-users-box/edit-project-users-box.component.ts